import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { getDateWithFormat } from "../../helpers/Utils";

import {
  TICKET_LIST_GET_LIST,
  TICKET_GET
} from "../actions";

import {
  getTicketListSuccess,
  getTicketListError,
  getTicketSuccess,
  getTicketError
} from "./actions";

import ticketListData from "../../data/ticket.list.json";
import { getRequest } from "../../helpers/api";

const getTicketListRequest = async () => {
  const tickets = ticketListData.data;
  const currentUser = tickets[0];
  return await new Promise((success, fail) => {
    setTimeout(() => {
      success({ tickets, currentUser });
    }, 2000);
  })
    .then(response => response)
    .catch(error => error);
};

function* getTicketListItems() {
  try {
    const response = yield call(getTicketListRequest);
    const { tickets, currentUser } = response;
    yield put(getTicketListSuccess(tickets, currentUser));
  } catch (error) {
    yield put(getTicketListError(error));
  }
}

const getTicketRequest = async (pid) => {
  return await new Promise((success, fail) => {
    setTimeout(() => {
      // const data = fetch("http://52.168.108.59/tickets/0dac1c91-206c-402d-b9ad-d9e4da355887")
      getRequest(`/tickets/${pid}`)
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          const ticket = data;
          success({ ticket });
        })
    })
  })
    .then(response => response)
    .catch(error => error);
};

function* getTicket({ payload }) {
  try {
    const response = yield call(getTicketRequest, payload);
    const { ticket } = response;
    yield put(getTicketSuccess(ticket));
  } catch (error) {
    yield put(getTicketError(error));
  }
}

export function* watchGetList() {
  yield takeEvery(TICKET_LIST_GET_LIST, getTicketListItems);
  yield takeEvery(TICKET_GET, getTicket);
}

export default function* rootSaga() {
  yield all([fork(watchGetList)]);
}


